import { useState } from 'react';
import { Route, Router } from 'preact-router';

import { Header } from './Header';
import { Footer } from './Footer';
import { CertificateBlock } from './CertificateBlock';
import { AnalyticsDebugPanel } from './AnalyticsDebugPanel';

import { isAnalyticsDebugEnabled } from '../lib/analytics';

import MainPage from '../routes/main';
import WindowsPage from '../routes/windows';
import MacPage from '../routes/mac';
import LinuxPage from '../routes/linux';
import IosPage from '../routes/ios';
import IosHaricaPage from '../routes/ios/harica';
import AndroidPage from '../routes/android';
import AndroidHaricaPage from '../routes/android/harica';
import HuaweiPage from '../routes/huawei';
import NotFoundPage from '../routes/notfound';
import ContactsPage from '../routes/contacts';

const routes = [
  { id: 1, path: '/windows', component: WindowsPage },
  { id: 2, path: '/mac', component: MacPage },
  { id: 3, path: '/linux', component: LinuxPage },
  { id: 4, path: '/ios', component: IosPage },
  { id: 5, path: '/android', component: AndroidPage },
  { id: 6, path: '/huawei', component: HuaweiPage },
  { id: 7, path: '/contacts', component: ContactsPage },
  { id: 8, path: '/ios/harica', component: IosHaricaPage },
  { id: 9, path: '/android/harica', component: AndroidHaricaPage },
];

const App = () => {
  // Текущий pathname: CertificateBlock шлёт scrollEvent только на главной (ss-22080)
  const [url, setUrl] = useState(() =>
    typeof window === 'undefined' ? '/' : window.location.pathname
  );

  /**
   * SPA не сбрасывает скролл при смене страницы: открыв инструкцию из нижней части
   * списка, пользователь попадал в середину новой страницы. Переходы по якорю
   * (#installation, #harica-installation) не трогаем — там скролл осмысленный.
   */
  const handleRouteChange = (e) => {
    // «/#installation» → «/», хэш-переход «#installation» → pathname не меняется
    setUrl(e.url.split('#')[0] || window.location.pathname);

    if (typeof window === 'undefined' || e.url.includes('#')) return;

    window.scrollTo(0, 0);
  };

  return (
    <>
      <CertificateBlock type="Минцифры" certType="mc" trackVisibility={url === '/'} />
      <div id="preact_root" className="responsive">
        <Header />

        <div>
          <Router onChange={handleRouteChange}>
            <Route exact path="/" component={MainPage} />
            <NotFoundPage default />
            {routes.map((item) => (
              <Route path={item.path} key={item.id} component={item.component} />
            ))}
          </Router>
        </div>

        <Footer />
      </div>

      {isAnalyticsDebugEnabled() && <AnalyticsDebugPanel />}
    </>
  );
};

export default App;
